define(
    'models/BannerCollection',[
        'underscore',
        'app',
        'ObjectCollection',
        'LocalStorage',
        'models/BannerModel',
    ],
    function (
        _,
        app,
        ObjectCollection,
        LocalStorage,
        BannerModel
    )
    {
    //
    // Collection Banner
    //
    var BannerCollectionPrototype = {
        name: 'BannerCollection',
        idAttribute: 'id_banner',
        route: 'apiBannerCollection',
        model: BannerModel,
        initialize: function ()
        {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
            //
        },
    };
    var BannerCollection = ObjectCollection.extend(LocalStorage).extend(BannerCollectionPrototype);

    return BannerCollection;
});
